import { useState, useEffect, useRef } from 'react';

const OBSERVER_OPTIONS = { threshold: 0.01, rootMargin: '100px' };
const VIEWPORT_MARGIN = 100;

export function useInView() {
  const [isInView, setIsInView] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const currentRef = ref.current;
    if (!currentRef) return;

    const rect = currentRef.getBoundingClientRect();
    const isAlreadyVisible = rect.top < window.innerHeight + VIEWPORT_MARGIN && rect.bottom > -VIEWPORT_MARGIN;

    if (isAlreadyVisible) {
      setIsInView(true);
      return;
    }

    const handleIntersection = ([entry]) => {
      if (entry.isIntersecting) {
        setIsInView(true);
        observer.disconnect();
      }
    };

    const observer = new IntersectionObserver(handleIntersection, OBSERVER_OPTIONS);
    observer.observe(currentRef);
    return () => observer.disconnect();
  }, []); // ref.current is a mutable ref — not a reactive dependency

  return [ref, isInView];
}
